import { useEffect, useState, useCallback, useRef } from "react";
import {
  useAMGSelectedContext,
  useCurrentPageActionContext,
  useMainGridSortContext,
  usePageSizeActionContext,
} from "./../../Context/GlobalContext";
import { useGlobalSpinnerActionsContext } from "./../../Context/GlobalSpinnerContext";
import equipmentGroupActions from "../../Actions/EquipmentGroupActions";
import _ from "lodash";
import EquipmentListTable from "./EquipmentListTable";
import { useLocation } from "react-router-dom";
import { _helper } from "../GlobalFunction/dateHelper";
import { filterlistProcessRequest } from "./MuiDataGridPro/HelperDashboard";
import {
  useEquipmentStatusContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
} from "../../Context/GridEquipListContext";
import {
  useTourGuidConfigActionsContext,
  useTourGuidConfigContext,
} from "../../Context/TourGuidContext";
import GridColumn_SettingActions from "../../Actions/GridColumn_SettingActions";
import NewEquipmentGroup from "../NewEqupmentGroup/NewEquipmentGroup";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import commonUtils from "../../helpers/commonUtils";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import UserManagementActions from "../../Actions/UserManagementActions";
import AppConstants from "../../Constants/AppConstants";
import Pruef_PlanActions from "../../Actions/Pruef_PlanActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";

function Dashboard() {
  const location = useLocation();
  const selectedAnlageG = useAMGSelectedContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const sortBy = useMainGridSortContext();
  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();
  const guideTourstate = useTourGuidConfigContext();
  const setGuideTourState = useTourGuidConfigActionsContext();
  const { localization } = useLanguageContext();
  const [renderSaveMsg, setRenderSaveMsg] = useState(null);
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();
  const equipmentStatus = useEquipmentStatusContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const [saveMsg, setSaveMsg] = useState(null);
  const [classname, setClassname] = useState(null);
  const [timeout, setTimeOut] = useState(2000);
  const [saveFilterList, setSaveFilterList] = useState([]);
  const [openEquipmentGrpConf, setOpenEquipmentGrpConf] = useState(false);
  const [egDetails, setEgDetails] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [plantId, setPlantId] = useState(0);
  const [functionsList, setFunctionsList] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const prevPlantId = useRef("");

  const reportCode = location.pathname.startsWith("/inspection")
    ? "OrdersOView"
    : "EquipList";

  const addLastCheckDateFilter = (FilterList) => {
    return [
      ...FilterList,
      {
        Name: "LastCheckDate",
        Value: _helper.lastCheckDateFromCurrent(30),
        Operator: ">",
      },
    ];
  };
  const buildFilterList = (reportCode, equipmentStatus, itemSelectedFilter) => {
    let FilterList = [...itemSelectedFilter];

    if (reportCode === "OrdersOView" && equipmentStatus === "not") {
      FilterList = addLastCheckDateFilter(FilterList);
    }

    if (reportCode === "EquipList" && itemSelectedFilter.length == 0) {
      FilterList = [
        ...FilterList,
        {
          Name: "AnlageStatus",
          Value: "INBE",
          Operator: "=",
          mapping: "is",
        },
      ];
    }

    if (equipmentStatus !== "not") {
      const processedFilters =
        equipmentStatus === ""
          ? FilterList
          : filterlistProcessRequest(FilterList, equipmentStatus, reportCode);
      if (processedFilters.length > 0) {
        FilterList = processedFilters;
      }
    }

    return FilterList;
  };

  const loadData = (callFilter) => {
    const EquipmentGroupID = selectedAnlageG;
    const defaultSortKey =
      reportCode === "EquipList" ? "InventarNr" : "pruefdatum";
    const sortOrder = sortBy.order === "" ? "asc" : sortBy.order;
    const sortKey = sortBy.key === "" ? defaultSortKey : sortBy.key;

    let FilterList = buildFilterList(
      reportCode,
      equipmentStatus,
      itemSelectedFilter,
    );

    equipmentGroupActions.getEquipmentList2(
      reportCode,
      sortOrder,
      EquipmentGroupID,
      parseInt(1),
      parseInt(1000),
      sortKey,
      null,
      FilterList,
    );

    GridColumn_SettingActions.getSaveFilterList(EquipmentGroupID, reportCode);
  };

  const getPlants = () => {
    UserManagementActions.getPlantsByUserId();
  };

  useEffect(() => {
    if (reportCode === "EquipList" && guideTourstate.tourActive) {
      setGuideTourState((prev) => ({
        ...prev,
        run: true,
        stepIndex: 1,
      }));
    }
    if (reportCode === "EquipList") {
      getPlants();
    }
  }, []);
  /**-------------Handle Grid Table Data Response start ------------------ */

  /**-------------Handle Grid Table Data Response start ------------------ */
  const fetchData = useCallback(() => {
    if (selectedAnlageG !== null && selectedAnlageG !== undefined) {
      setGlobalSpinner(true);
      loadData(true);
    }
  }, [selectedAnlageG, location.pathname]);

  useEffect(() => {
    fetchData();
    return () => {};
  }, [fetchData]);

  useEffect(() => {
    let _renderSaveMsg =
      saveMsg === null ? null : (
        <div className={classname}>
          <p className="lead">{saveMsg}</p>
        </div>
      );

    const _timeout = setTimeout(() => {
      setRenderSaveMsg(null);
      setSaveMsg(null);
      setClassname(null);
    }, timeout);

    setRenderSaveMsg(_renderSaveMsg);

    return () => {
      clearTimeout(_timeout);
    };
  }, [saveMsg, classname, timeout]);

  function handlePaginationCallApi(pageValue, _filterlist) {
    UpdateCurrentPage(pageValue.page);
    UpdatePageSize(pageValue.pageSize);
    setGlobalSpinner(true);
    equipmentGroupActions.getEquipmentList2(
      reportCode,
      sortBy.order,
      selectedAnlageG,
      parseInt(pageValue.page),
      parseInt(pageValue.pageSize),

      sortBy.key,

      null,
      _filterlist,
    );
  }

  function openEquipmentGroupConf() {
    if (reportCode === "EquipList") {
      setGlobalSpinner(true);
      EquipmentGroupActions.getSummaryEqGrp(selectedAnlageG);
      EquipmentGroupActions.getParticularEqGrp(selectedAnlageG);
    }
    setOpenEquipmentGrpConf(true);
  }

  const reloadEquipmentGroupList = () => {
    setPlantId(prevPlantId.current);
  };

  const closeCreatePopOver = () => {
    setEgDetails("");
    setOpenEquipmentGrpConf(false);
  };

  useEffect(() => {
    if (egDetails != null && egDetails != "" && plantList.length > 0) {
      let filteredPlant = plantList.filter((item) => {
        return item.id == egDetails.werk;
      });

      setPlantId(
        filteredPlant.length > 0
          ? filteredPlant[0].id
          : AppConstants.DEFAULT_GUID,
      );
    }

    return () => {};
  }, [egDetails]);

  useEffect(() => {
    function getEqGrpSuccess() {
      var res = equipmentGroupStore.getPaticularEqGrpResult();
      if (res && res != "") {
        commonUtils.setIsEdit(true);
        setEgDetails(res);
      }
    }

    function getEqGrpFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PARTICULE_EQ_GRP_SUCCESS,
      getEqGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PARTICULE_EQ_GRP_FAILURE,
      getEqGrpFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_PARTICULE_EQ_GRP_SUCCESS,
        getEqGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_OPTION_EQUIP_GRP_FAILURE,
        getEqGrpFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getPlantSuccess() {
      var res = usermanagementStore.getPlantResult();

      if (res.length > 0) {
        setPlantList(res);
      } else {
        setPlantList([]);
      }
    }

    function getPlantFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_TEMPLATE":
          setGlobalSpinner(true);
          Pruef_PlanActions.deleteChecklistTemplate(data);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function handleActionButtons(action, rowData) {
    switch (action) {
      case "DELETE_TEMPLATE":
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(localization.deleteConfirmation);
        setCallbackData(rowData);
        setEventType("DELETE_TEMPLATE");
        break;
    }
  }

  return (
    <>
      <div className="container-fluid overflow-hidden" id="content">
        <div>
          <div className="row">
            <div className="column"></div>
            <div className="column">
              <div style={{ textAlign: "center" }}>{renderSaveMsg}</div>
            </div>
          </div>
        </div>

        <div id="dataGrid" className="container-fluid dataGridPro">
          <EquipmentListTable
            reportCode={reportCode}
            saveFilterList={saveFilterList}
            handlePaginationCallApi={handlePaginationCallApi}
            handleOpenEquipmentGrpConf={openEquipmentGroupConf}
          />
        </div>
      </div>
      {openEquipmentGrpConf && (
        <NewEquipmentGroup
          egDetails={egDetails}
          plantList={plantList}
          selectedPlantId={plantId}
          equMenuList={menuList}
          orgFunctionsList={functionsList}
          reloadEquipmentGroupList={reloadEquipmentGroupList}
          closeCreatePopOver={closeCreatePopOver}
          equGrpDetails={""}
          setEgDetails={setEgDetails}
          handleActionButtons={handleActionButtons}
        />
      )}

      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
}

export default Dashboard;
